import { combineReducers } from 'redux'
import apples from './apples'

export default combineReducers({
  apples
})
